const useCase = {
  HasRequiredPermissionsUseCase: Symbol(),
}

export default {
  useCase,
}
